import React, { lazy, Suspense, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { CurrentPeriod } from 'App/components/CurrentPeriod'
import Loading from 'App/components/Loading/Loading'
import { ClassesTotal, SchoolLevels } from 'App/views/TeacherClasses/components'
import { PersonContext } from 'App/views/TeacherClasses/TeacherClassesContexts'

import { ROUTES } from 'utils/constants'
import { getCookieLoggedName } from 'utils/token'

import UserContext from '../../../stores/UserStore'

const TeacherClasses = () => (
  <CurrentPeriod>
    <ClassesTotal>
      <SchoolLevels>
        {/* eslint-disable-next-line @typescript-eslint/no-use-before-define */}
        <TeacherClassesViews />
      </SchoolLevels>
    </ClassesTotal>
  </CurrentPeriod>
)

const TeacherClassesViews = () => {
  const { levelId } = useParams()
  const navigate = useNavigate()
  const person = { ...useContext(PersonContext) }
  const userStore = useContext(UserContext)

  const returnButtonUrl = () => {
    if (userStore.needSelectProfile) {
      return ROUTES.PERFIL_DADOS_ESCOLARES_FUNCOES_PROFESSOR
    }
    if (userStore.needSelectProfileCoordinator) {
      return ROUTES.PERFIL_DADOS_ESCOLARES_FUNCOES_COORDENADOR
    }
    return `${ROUTES.PERFIL_DADOS_ESCOLARES}?redirect=true`
  }

  const handleNavigationToBack = () => navigate(returnButtonUrl())

  const WidgetTeacherClasses = lazy(() => import('./index'))

  return (
    <Suspense Suspense fallback={<Loading fullscreen size='large' />}>
      <WidgetTeacherClasses
        descriptionHeader={`Para visualizar as turmas da escola ${person.school.tradeName}, expanda sua disciplina.`}
        teacherId={+person?.id}
        handleNavigationToBack={handleNavigationToBack}
        schoolId={+person.school.id}
        nameTeacher={person.name}
        handleFinishNextStep={handleNavigationToBack}
        selectedSegment={+levelId || undefined}
        nodeEnv={getCookieLoggedName()}
      />
    </Suspense>
  )
}

export { TeacherClasses }
